import Div from '@/shared/Div';
import Filter from '@/components/Icons/Filter';
import React, { Suspense, memo } from 'react';
import ChevronDownIcon from '../Icons/ChevronDownIcon';
import type { SortByItem } from '@/components/SortByFilter';
import is from '@/utils/is';

type FiltersProps = {
  handleOpenModal: (type: 'filter' | 'sort') => void;
  show: boolean;
  open: boolean;
  filters: any;
  applySortByFilter?: SortByItem;
  modalType: 'filter' | 'sort' | null;
  closeModal: () => void;
  onApplyFilter: (a: any) => void;
  onResetFilter: () => void;
  onApplySortBy: (sortByList: any) => void;
};

const ProductFilter = React.lazy(
  () => import(/* webpackChunkName: "plp-filter-lazy-chunks" */ '@/components/ProductFilter'),
);

const SortByFilter = React.lazy(
  () => import(/* webpackChunkName: "plp-filter-lazy-chunks" */ '@/components/SortByFilter'),
);

const Filters = ({
  handleOpenModal,
  show,
  open,
  closeModal,
  filters,
  modalType,
  applySortByFilter,
  onApplyFilter,
  onResetFilter,
  onApplySortBy,
}: FiltersProps) => {
  if (!show) return null;

  const renderModal = () => {
    if (open) {
      if (modalType === 'filter') {
        return (
          <Suspense>
            <ProductFilter
              filters={filters}
              onApplyFilter={onApplyFilter}
              onResetFilter={onResetFilter}
              open={open}
              closeModal={closeModal}
            />
          </Suspense>
        );
      }
      if (modalType === 'sort') {
        return (
          <Suspense>
            <SortByFilter
              applySortByFilter={applySortByFilter}
              onApplySortBy={onApplySortBy}
              open={open}
              closeModal={closeModal}
            />
          </Suspense>
        );
      }
    }
    return null;
  };

  return (
    <Div className="flex gap-s3  justify-center">
      {is.empty.object(filters) ? null : (
        <Div
          className="flex gap-s3 border border-cm-subtle px-s5 py-s3 rounded-3xl text-body-lg cursor-pointer"
          onClick={() => handleOpenModal('filter')}
        >
          <Filter /> All Filters
        </Div>
      )}

      <Div
        className="flex gap-s3 border border-cm-subtle px-s5 py-s3 rounded-3xl text-body-lg cursor-pointer relative group"
        onClick={() => handleOpenModal('sort')}
      >
        Sort by <ChevronDownIcon fill="#171717" />
      </Div>
      {renderModal()}
    </Div>
  );
};

export default memo(Filters);
